module.exports = __webpack_public_path__ + "components/blogs-header/static/header--large@2x-782b59ce416ef0559c23551a6eb53696.jpg";